import { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import varAxios from '../Comman/axios'
import formDataAxios from '../Comman/formDataAxios'

class ContextComponent extends Component {
    componentWillMount() {
        var interceptorFunction = bind(this, function (config) {
            
            config.headers.selectedEntity = '';
            
            if (localStorage.getItem('id_admin_token')) {           
                config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_admin_token');
            }
            else if(sessionStorage.getItem('id_super_admin_token')){
                config.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('id_super_admin_token');

            }
            else if(localStorage.getItem('userid_token')){
                config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('userid_token');

            }
            else {
                config.headers.common['Authorization'] = ""
            }
            return config;
        });

        varAxios.interceptors.request.use(interceptorFunction,
            function (error) {
                
                // Do something with request error
                return Promise.reject(error);
            });
        formDataAxios.interceptors.request.use(interceptorFunction,
            function (error) {
                
                // Do something with request error
                return Promise.reject(error);
            });
    };

    render() {
        return null;
    };
}

function bind(scope, funct) {
    return function () {
        return funct.apply(scope, arguments);
    };
};

function mapStateToProps({ contextReducer }) {
    return {
        
    }
};


export default withRouter(connect(mapStateToProps, null)(ContextComponent))